var _defs, _polyline, _polyline2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqureplacket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-142,.cls-141,.cls-140{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-142{stroke-width:3px;}.cls-141{stroke-width:1.02px;}.cls-141,.cls-140{stroke-dasharray:4;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-142",
    points: "280.99 106.33 280.99 387.02 214.58 387.02 147.81 387.02 147.81 106.33"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-141",
    points: "277.66 106.33 277.66 382.98 214.92 383.65 151.14 383.07 151.14 106.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-140",
    x1: 151.14,
    y1: 213.67,
    x2: 280.99,
    y2: 213.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqureplacket01);
export default __webpack_public_path__ + "static/media/SQURE PLACKET-01.11d1e7b4d8cb5e8994f4f404cdbf8a11.svg";
export { ForwardRef as ReactComponent };